export default __webpack_public_path__ + "static/media/X.d4f11475.svg";